import { Decimal } from 'decimal.js'
import TradingFormula from '@bei/trading-formula'

import Utils from '@/utils/index.js'

export default {
	data() {
		return {
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		goldBalances() {
			let goldBalance = []

			let holdingsSequence = this.$store.state.holdingsSequence
			if (this.$store.getters.paymentMethod === 'gopay') {
				holdingsSequence = this.$store.state.holdingsSequenceForGopay
			}

			holdingsSequence.forEach((contractId) => {
				const found = this.$store.getters['goldBalanceNew/getGoldBalanceByNewContractId'](contractId)
				if (found) {
					goldBalance.push(found)
				}
			})

			return goldBalance
		},

	},

	methods: {
		pricePerGramSellUsd(contractId) {
			const golds = this.$store.state.golds

			if (!golds) {
				return -1
			}

			const tempGold = golds[contractId]
			if (!tempGold) {
				return -1
			}

			return tempGold.pricePerGramSell
		},

		countMetalValueAtDateNew(contractId, totalGram) {
			const metalValueAtDate = TradingFormula.tradeTicket.getTotal({
				contractValueUsd: Decimal.mul(this.pricePerGramSellUsd(contractId), totalGram).toFixed(this.$store.state.fractionDigit.usd),
				direction: 'sell',
				orderType: 'market',
				currency: this.currency,
				rateUsdToCurrency: this.streamingRate.streamSell,
				rateCurrencyToIdr: this.streamingRate.streamSell,
			})

			// console.log('metalValueAtDate', contractId, totalGram, save, metalValueAtDate)

			return metalValueAtDate
		},
		metalValueAtDateNewShown(contractId, totalGram) {
			const metalValueAtDate = this.countMetalValueAtDateNew(contractId, totalGram)

			if (new Decimal(metalValueAtDate).lessThan(0)) {
				return '-'
			}

			const temp = `${this.currencySymbol}` + Utils.currencyFormat(metalValueAtDate, this.currency)

			return temp
		},

		countUnrealizedPnl(holding) {
			const contractId = holding.contract_id
			const totalGram = holding.remaining_quantity
			const totalPriceBuy = this.currency == 'idr' ? holding.remaining_cost_idr : holding.remaining_cost_usd

			const totalPriceSell = this.countMetalValueAtDateNew(contractId, totalGram)

			const estimasiProfit = Decimal.sub(totalPriceSell, totalPriceBuy)

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return estimasiProfit.toFixed(fractionDigits)
		},
		unrealizedPnlShown(holding) {
			const pnl = this.countUnrealizedPnl(holding)

			if (!pnl) {
				return '0'
			}

			// if estimated profit < 0 show minus sign before the currency
			let sign = ''
			if (new Decimal(pnl).lessThan(0)) {
				sign = '-'
			} else if (new Decimal(pnl).greaterThan(0)) {
				sign = '+'
			}

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			const returnValue = `${sign}${this.currency == 'idr' ? 'Rp' : '$'}` + Utils.currencyFormat(new Decimal(pnl).abs().toFixed(fractionDigits), this.currency)
			return returnValue
		},

		countUnrealizedPnlPercentage(holding) {
			const pnl = this.countUnrealizedPnl(holding)
			const totalPriceBuy = this.currency == 'idr' ? holding.remaining_cost_idr : holding.remaining_cost_usd

			if (!totalPriceBuy) {
				return 0
			}

			const pnlPercentage = new Decimal(pnl).dividedBy(totalPriceBuy).times(100).toFixed(2)

			return pnlPercentage
		},
		unrealizedPnlPercentageShown(holding) {
			const pnlPercentage = this.countUnrealizedPnlPercentage(holding)
			if (!pnlPercentage) {
				return '(0%)'
			}

			const sign = new Decimal(pnlPercentage).greaterThan(0) ? '+' : '-'

			return `(${sign}${new Decimal(pnlPercentage).abs()}%)`
		},

		nominalDiterimaShown(holding) {
			let nominalDiterima
			if (this.currency == 'idr') {
				nominalDiterima = holding.sold_amount_idr
			} else {
				nominalDiterima = holding.sold_amount_usd
			}

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return this.currencySymbol + Utils.currencyFormat(new Decimal(nominalDiterima).toFixed(fractionDigits), this.currency)
		},

		countRealizedPnl(holding) {
			let sellPrice, buyPrice, fractionDigits
			if (this.currency == 'idr') {
				sellPrice = holding.sold_amount_idr
				buyPrice = holding.sold_cost_idr
				fractionDigits = this.$store.state.fractionDigit.idr
			} else {
				sellPrice = holding.sold_amount_usd
				buyPrice = holding.sold_cost_usd
				fractionDigits = this.$store.state.fractionDigit.usd
			}

			const realizedPnl = new Decimal(sellPrice).minus(buyPrice).toFixed(fractionDigits)
			return realizedPnl
		},
		realizedPnlShown(holding) {
			const realizedPnl = this.countRealizedPnl(holding)
			if (!realizedPnl) {
				return '0'
			}

			let sign = ''
			if (new Decimal(realizedPnl).lessThan(0)) {
				sign = '-'
			} else if (new Decimal(realizedPnl).greaterThan(0)) {
				sign = '+'
			}

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return `${sign}${this.currencySymbol}` + Utils.currencyFormat(new Decimal(realizedPnl).abs().toFixed(fractionDigits), this.currency)
		},

		countRealizedPnlPercentage(holding) {
			let sellPrice, buyPrice
			if (this.currency == 'idr') {
				sellPrice = holding.sold_amount_idr
				buyPrice = holding.sold_cost_idr
			} else {
				sellPrice = holding.sold_amount_usd
				buyPrice = holding.sold_cost_usd
			}

			if (!buyPrice) {
				return '0'
			}

			const realizedPnlPercentage = new Decimal(sellPrice).minus(buyPrice).dividedBy(buyPrice).times(100).toFixed(2)

			return realizedPnlPercentage
		},
		realizedPnlPercentageShown(holding) {
			const realizedPnlPercentage = this.countRealizedPnlPercentage(holding)
			if (!realizedPnlPercentage) {
				return '(0%)'
			}
			let sign = ''
			if (new Decimal(realizedPnlPercentage).lessThan(0)) {
				sign = '-'
			} else if (new Decimal(realizedPnlPercentage).greaterThan(0)) {
				sign = '+'
			}

			return `(${sign}${new Decimal(realizedPnlPercentage).abs().toFixed()}%)`
		},
	}
}